<template>
  <div class="app-navigation">
    <div class="navigation-controll signin-switcher" @click="swithUserClick">
      <user-portrate :target="currentUser" :displaySize="'small'" v-if="currentUser" />
      <span class="caption">{{ currentSigninNameTruncated }}</span>
    </div>
    <div class="navigation-controll favorite" @click="favoriteClick">
      <img src="/images/favourite_on.svg" v-show="currentPath === '/favourite'" />
      <img src="/images/favourite_off.svg" v-show="currentPath !== '/favourite'" />
      <span class="caption">お気に入り</span>
    </div>
    <div class="navigation-controll address-book" @click="addressBookClick">
      <img src="/images/address_on.svg" v-show="currentPath === '/address_book'" />
      <img src="/images/address_off.svg" v-show="currentPath !== '/address_book'" />
      <span class="caption">連絡先</span>
    </div>
    <div class="navigation-controll history" @click="historyClick">
      <img src="/images/history_on.svg" v-show="currentPath === '/history'" />
      <img src="/images/history_off.svg" v-show="currentPath !== '/history'" />
      <span class="caption">履歴</span>
    </div>
    <div class="navigation-controll config" @click="configClick">
      <img src="/images/configure_on.svg" v-show="currentPath === '/config'" />
      <img src="/images/configure_off.svg" v-show="currentPath !== '/config'" />
      <span class="caption">設定</span>
    </div>
  </div>
  <user-switch-modal
    :currentUser="currentUser"
    :availableUsers="activeUsers"
    :switchUserModalDisplay="switchUserModalDisplay"
    v-on:userSelectedEvent="userSelected"
    v-on:cancelEvent="coloseUserSelect"
    />
</template>

<script>
import { mapState, mapActions } from 'vuex'

import UserPortrate from '@/components/appView/common/UserPortrate.vue'
import UserSwitchModal from '@/components/appView/common/UserSwitchModal.vue'

export default {
  name: 'AppNavigation',

  components: {
    UserPortrate,
    UserSwitchModal,
  },

  data () {
    return {
      switchUserModalDisplay: false
    }
  },

  computed: {
    ...mapState({
      currentUser: state => state.user.currentUser,
      currentDevice: state => state.user.currentDevice,
      availableUsers: state => state.user.users,
    }),

    activeUsers () {
      return this.availableUsers.filter((user) => user.user_state === 2 
        && ((this.currentDevice.push_target === 0 && user.ios_zoom_available) 
        || (this.currentDevice.push_target === 1 && user.android_zoom_available))
      )
    },

    currentSigninName () {
      if (this.currentUser) {
        return this.currentUser.name
      }
      return 'no signin'
    },

    currentPath () {
      return this.$route.path
    },

    currentSigninNameTruncated () {
      if (this.currentUser && this.currentSigninName) {
        return this.currentSigninName.length <= 6 ? this.currentSigninName : (this.currentSigninName.substr(0, 6) + '...')
      }
      return '-------'
    },
  },

  methods: {
    ...mapActions({
      switchAccount: 'user/switchAccount',
    }),

    switchUser (user) {
      this.switchAccount(user.account_name)
    },

    swithUserClick () {
      this.switchUserModalDisplay = true
    },

    userSelected (user) {
      this.switchUser(user)
      this.switchUserModalDisplay = false
    },

    coloseUserSelect () {
      this.switchUserModalDisplay = false
    },

    favoriteClick () {
      this.$router.push({ path: '/favourite' })
    },

    addressBookClick () {
      this.$router.push({ path: '/address_book' })
    },

    historyClick () {
      this.$router.push({ path: '/history' })
    },

    configClick () {
      this.$router.push({ path: '/config' })
    },
  }
}
</script>

<style lang="scss" scoped>
.app-navigation {
  margin: 0;
  padding: 10px 20px;
  display: flex;
  height: 70px;
  justify-content: space-between;
  align-items: center;
  background-color: #ddd;
  .navigation-controll {
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      height: 40px;
    }
    .caption {
      text-align: center;
      margin-top: 5px;
      font-size: 10px;
    }
    &.signin-switcher {
      .caption {
        // display: inline-block;
        width: 70px;
      }
    }
  }
}
</style>